import React from "react";
import { connect } from "react-redux";
import Entities from '../common/Entities';
import ServiceTable from "./ServiceTable";
import ServiceEditModal from "./ServiceEditModal"
import Filter from "./Filter";
import { Map } from "immutable";

import {
    fetchServices as fetchServicesAction,
    updateService as updateServiceAction,
    createService as createServiceAction,
    clearCreateService as clearCreateServiceAction,
    clearUpdateService as clearUpdateServiceAction
} from "../../actions/services";
import { fetchCategories as fetchCategoriesAction } from '../../actions/categories';

import * as fetchingState from '../../constants/fetchingState';
import * as permissions from '../../constants/permissions';

const categoryAll = { Id: 0, Name: 'Все' };
const isActiveStates = [
    { Value: null, Name: 'Все' },
    { Value: true, Name: 'Да' },
    { Value: false, Name: 'Нет' },
];
const sortByName = (prev, next) => (prev.Name < next.Name ? -1 : 1);
let ServicesTab = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: {
                category: categoryAll,
                isActive: isActiveStates.find(s => s.Value)
            }
        }
        this._loadServices = this._loadServices.bind(this);
        this._createService = this._createService.bind(this);
        this._updateService = this._updateService.bind(this);
        this._clearCrudAction = this._clearCrudAction.bind(this);
        this._filterChanged = this._filterChanged.bind(this);
        this.renderFilter = this.renderFilter.bind(this);
    }

    componentDidMount() {
        const { categories, categoriesFetching, fetchCategoriesAction } = this.props;
        if (categoriesFetching !== fetchingState.FETCHING && categories.length === 0)
            fetchCategoriesAction();
    }

    _loadServices() {
        this.props.fetchServicesAction(this.state.filter);
    }

    _clearCrudAction(isNew) {
        isNew ? this.props.clearCreateServiceAction() : this.props.clearUpdateServiceAction();
    }

    _createService(service) {
        this.props.createServiceAction(service);
    }

    _updateService(service) {
        this.props.updateServiceAction(service);
    }

    _filterChanged(filterData) {
        this.setState({
            filter: { ...filterData }
        });
    }

    renderFilter() {
        const { categories, categoriesFetching } = this.props;
        const allCategories = [categoryAll].concat(categories.filter(c => c.IsActive).sort(sortByName));

        const filterProps = {
            onChange: this._filterChanged,
            categories: allCategories,
            categoriesFetching,
            isActiveStates,
            initialValues: {
                ...this.state.filter
            }
        }

        return <Filter {...filterProps} />
    }

    render() {
        const { services, fetching, createFetching, updateFetching, categories } = this.props;
        const categoriesMap = (new Map()).withMutations(cm => {
            categories.forEach(c => {
                cm.set(c.Id, c);
            });
        });
        const entities = services.map(s => (
            {
                ...s,
                Categories: s.Categories.map(id => categoriesMap.get(id)).sort(sortByName)
            })).sort(sortByName);

        return (
            <div>
                {this.renderFilter()}
                <Entities
                    entities={entities}
                    fetching={fetching}
                    createFetching={createFetching}
                    updateFetching={updateFetching}
                    contentTable={ServiceTable}
                    editModal={ServiceEditModal}
                    createAction={this._createService}
                    updateAction={this._updateService}
                    clearCrudAction={this._clearCrudAction}
                    loadAction={this._loadServices}
                    header='Услуги'
                    createDisabled={!permissions.isAllowedFor(permissions.allowedEditServices)}
                />
            </div>
        );
    }

}

ServicesTab = connect(state => {
    const service = state.application.get('serviceCategory').get('service');
    const category = state.application.get('serviceCategory').get('category');
    return {
        ...service,
        categories: category.categories,
        categoriesFetching: category.fetching
    };
}, {
    fetchServicesAction,
    updateServiceAction,
    createServiceAction,
    clearCreateServiceAction,
    clearUpdateServiceAction,
    fetchCategoriesAction
})(ServicesTab);

export default ServicesTab;


// WEBPACK FOOTER //
// ./src/components/services/ServicesTab.jsx